<template>
  <div>
    <van-skeleton
      avatar
      :row="3"
      :loading="loading"
    >
      <van-row gutter="8">
        <van-col span="2">
          <!-- <img :src="SenderAvatar" style="width:100%;border-radius:50%" /> -->
          <img :src="giftCard.sender.wechat_profile.headimgurl" style="width:100%;border-radius:50%" />
        </van-col>
        <van-col span="22">
          <van-row type="flex" justify="space-between" align="center">
            <van-col span="10">
              <!-- <strong>{{SenderName}}</strong> -->
              <strong>{{giftCard.sender.wechat_profile.nickname}}</strong>
            </van-col>
            <van-col span="14" style="display:flex;justify-content:flex-end;">
              <!-- <template v-if="giftCard.available_count > 0">
                <van-button
                  type="info"
                  size="mini"
                  style="margin-right:4px;"
                  @click="createInvitation"
                  :loading="sendInviationLoading"
                  :disabled="sendInviationLoading"
                  loading-text=""
                  loading-size="10px"
                >送好友</van-button>
              </template> -->
              <!-- <van-tag plain type="default">已用{{giftCard.quota - giftCard.available_count}}张 / 可用{{giftCard.available_count}}张</van-tag> -->
              <!-- <van-tag
                plain
                type="default"
                @click="giftCardDetail"
              >可用{{giftCard.available_count}}张</van-tag> -->
              <van-button
                v-if="listMode"
                plain
                :type="availableBtnType"
                size="mini"
                :disabled="availableBtnDisabled"
                @click="giftCardDetail"
              >
                可用{{giftCard.available_count}}张
              </van-button>
            </van-col>
          </van-row>
          <!-- <div class="content">
            “{{giftCardData.note}}”
          </div> -->
        </van-col>
      </van-row>
    </van-skeleton>
  </div>
</template>

<script>
  const wx = require('weixin-js-sdk')
  import Vue from 'vue'
  import { Row, Col } from 'vant'
  import { Image } from 'vant'
  import { Icon } from 'vant'
  import { Skeleton } from 'vant'
  import { Toast } from 'vant'
  import { Tag } from 'vant'
  Vue.use(Row).use(Col)
  Vue.use(Image)
  Vue.use(Icon)
  Vue.use(Skeleton)
  Vue.use(Toast)
  Vue.use(Tag)

  export default {
    name: "gift-card-detail",
    components: {
    },
    props: {
      listMode: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        required: false
      },
      giftCardData: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        loading: false,
        sendInviationLoading: false,
        giftCard: {
          id: 0,
          available_count: 0,
          note: '',
          quota: 0,
          sender: {
            id: 0,
            wechat_profile: {
              city: '',
              country: '',
              gender: 0,
              headimgurl: '',
              language: '',
              nickname: '',
              province: ''
            }
          }
        }
      }
    },
    computed: {
      availableBtnType () {
        let type = 'default'
        if (this.giftCard.available_count > 0) {
          type = 'info'
        }
        return type
      },
      availableBtnDisabled () {
        let disabled = false
        if (!this.listMode) {
          disabled = true
        }
        return disabled
      }
    },
    methods: {
      getGiftCard () {
        window.console.log(wx)
        // window.console.log("get gift card...")
        // let that = this
        // that.$api.giftcard.detail(giftCardId).then(res => {
        //   window.console.log(res)
        //   that.giftCard = res.data
        // })
      },
      createInvitation () {
        window.console.log("创建邀请")
        this.sendInviationLoading = true
      },
      giftCardDetail () {
        window.console.log("礼品卡详情")
        this.$router.replace({
          name: 'GiftCardDetailPage',
          params: {
            giftcardId: this.giftCard.id
          }
        })
      }
    },
    watch: {
      id (value) {
        window.console.log("礼品卡ID发生变化")
        window.console.log(value)
        this.getGiftCard(value)
      },
      giftCardData (value) {
        window.console.log("礼品卡数据发生变化")
        this.giftCard = value
      }
    },
    mounted () {
      // this.getGiftCard()
      if (this.id) {
        window.console.log("有id")
      } else if (this.giftCardData) {
        this.giftCard = this.giftCardData
      }
    }
  }
</script>

<style lang="css" scoped>
  .content {
    font-size: 0.98em;
  }
  .content-removed {
    color: #999;
  }
  .meta {
    font-size: 0.9em;
    color: #999;
  }
  .button {
    /* margin-left: 15px; */
    padding: 0 5px;
  }
  .reply {
    margin: 0 8px;
    color: #999;
  }
</style>
